import {
	SET_MODAL_OPEN, SET_MODAL_TEMPLATE, SET_MODAL_DATA, SET_MODAL_STATE,
} from '../actions/modal';
import { Action } from '../types/types';

export const MODAL_TEMPLATES = {
	EMPTY: '',
	EVENT_SETTINGS: 'event-settings',
	STREAM_DESTINATION_SETTINGS: 'stream-destination-settings',
	AVATAR_PHOTO: 'avatar-photo',
	SHOT_BUILDER: 'shot-builder',
	DELETE_SHOT_CONFIRMATION: 'delete-shot-confirmation',
	COPY_EVENT: 'copy-event',
	DELETE_EVENT_CONFIRMATION: 'delete-event-confirmation',
	PROGRAM_FEED: 'program-feed',
	ONSITE_FEED: 'onsite-feed',
	VIDEO_EDITOR: 'video-editor',
	DELETE_ACCOUNT: 'delete-account',
	PRESENTER_ONBOARDING_TUTORIAL_VIDEO: 'presenter-tutorial-video',
	HELP_MENU_TUTORIAL_VIDEO: 'producer-tutorial-video',
	MULTI_ACCOUNT_LOGGED_IN: 'multi-account-logged-in',
	LIVE_STREAM_CONFIRMATION: 'live-stream-confirmation',
	DELETE_CHAT_MESSAGE_CONFIRMATION: 'delete-chat-message-confirmation',
	NO_ROOM_ACCESS: 'no-room-access',
};

export const MODAL_INFO_ACTIONS = {
	ADD: 'add',
	EDIT: 'edit',
	DELETE: 'delete',
	INVITE: 'invite',
};

export const MODAL_AVATAR_ACTIONS = {
	AVATAR: 'avatar',
	CHANNEL_ICON: 'channel-icon',
};

export const initialModalState: ModalState = {
	modalOpen: false,
	modalTemplate: '',
	modalData: {},
};

export interface ModalState {
	modalOpen: boolean;
	modalTemplate: string;
	modalData: any;
}

const initialState: ModalState = {
	modalOpen: false,
	modalTemplate: MODAL_TEMPLATES.EMPTY,
	modalData: {},
};

const actions: Map<string, Function> = new Map([
	[SET_MODAL_OPEN, (state: ModalState, action: Action) => (
		{ ...state, modalOpen: action.payload }
	)],
	[SET_MODAL_TEMPLATE, (state: ModalState, action: Action) => (
		{ ...state, modalTemplate: action.payload }
	)],
	[SET_MODAL_DATA, (state: ModalState, action: Action) => (
		{ ...state, modalData: action.payload }
	)],
	[SET_MODAL_STATE, (state: ModalState, action: Action) => (
		{ ...state, ...action.payload }
	)],
]);

// eslint-disable-next-line default-param-last
export function ModalReducer(state: ModalState = initialState, action: Action) {
	return actions.get(action.type)?.(state, action) || state;
}
